import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import { global } from "../../utils"

import {
    Settings,
    UpdateNickname,
    UpdateEmail,
    UpdatePhone,
    ResetUserPassword,
    AppLanguage
} from "../SharedContainer"

class SettingsRoots extends React.Component {

    render() {
        const { isLogin, history } = this.props;
        if (!isLogin) {
            history.push("/SignIn");
            return null;
        }
        return (
            <Switch>
                <Route exact path="/settings" component={Settings} />
                <Route exact path="/settings/change-nickname" component={UpdateNickname} />
                <Route exact path="/settings/change-email" component={UpdateEmail} />
                <Route exact path="/settings/change-phone" component={UpdatePhone} />
                <Route exact path="/settings/password-reset" component={ResetUserPassword} />
                <Route exact path="/settings/languages" component={AppLanguage} />

            </Switch>
        )
    }
}
const mapStateToProps = ({ auth }) => {
    return { isLogin: auth.isLogin }
}
export default connect(mapStateToProps)(SettingsRoots);